<template>
    <div>
        <select-all-checkbox
            @input="emitInput"
            :name="selectAllName"
            :select-value="allValues"
            style="margin-bottom: 15px;"
            :value="value"
            v-if="selectAll"
        ></select-all-checkbox>
        <div v-for="(group, groupIndex) in groups" style="margin-bottom:15px;" :key="group[groupKey]">
            <div>{{ group.name }}</div>
            <select-all-checkbox
                :deselect-value="group[optionsRef].map(option => option[optionValueRef])"
                :id="`select-all-${groupIndex}-group-${selectAllName}`"
                @input="selectAllGroup"
                :name="`select-all-${groupIndex}-group-${selectAllName}`"
                :select-value="group[optionsRef].map(option => option[optionValueRef])"
                :value="value"
                v-if="selectAllByGroup && group[optionsRef].map(option => option[optionValueRef]).length > 1"
            ></select-all-checkbox>
            <div
                :aria-describedby="name"
                :id="name"
                role="group"
                tabindex="-1"
            >
                <div
                    class="custom-control custom-control-inline custom-checkbox"
                    :key="option[optionValueRef]"
                    v-for="(option, index) in group[optionsRef]"
                >
                    <input
                        autocomplete="off"
                        :checked="value.includes(option[optionValueRef])"
                        class="custom-control-input"
                        :id="`${name}-checkbox-list-${groupIndex}-${index}`"
                        @input="checked"
                        :name="`${name}[${allValues.indexOf(option[optionValueRef])}]`"
                        type="checkbox"
                        :value="option[optionValueRef]"
                    >
                    <label
                        :for="`${name}-checkbox-list-${groupIndex}-${index}`"
                        class="custom-control-label"
                    >
                        <slot name="labelText" :option="option">
                            <span>{{ option[optionLabelRef] }}</span>
                        </slot>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectAllCheckbox from "./SelectAllCheckbox.vue";

export default {
    name: 'GroupedCheckboxList',

    components: {
        SelectAllCheckbox,
    },

    props: {
        groupKey: {
            required: true,
            type: [Number, String],
        },
        groups: {
            required: true,
            type: Array,
        },
        name: {
            required: true,
            type: String,
        },
        optionLabelRef: {
            default: 'text',
            required: false,
            type: String,
        },
        optionsRef: {
            default: 'options',
            required: false,
            type: String,
        },
        optionValueRef: {
            default: 'value',
            required: false,
            type: String,
        },
        selectAll: {
            default: true,
            required: false,
            type: Boolean,
        },
        selectAllByGroup: {
            default: true,
            required: false,
            type: Boolean,
        },
        selectAllName: {
            default: 'select-all-checkbox',
            required: false,
            type: String,
        },
        value: {
            required: true,
            type: Array,
        },
    },

    computed: {
        allValues() {
            return this.options.map(option => option[this.optionValueRef]);
        },
        options() {
            return this.groups.map(group => group[this.optionsRef]).flat();
        },
    },

    methods: {
        checked(e) {
            let checkedOption = this.findCheckedOption(e.target.value),
                newVal = this.value.indexOf(checkedOption[this.optionValueRef]) === -1
                    ? [...this.value, checkedOption[this.optionValueRef]]//if the checkbox value IS NOT in the array, INSERT it
                    : [...this.value].filter(value => value !== checkedOption[this.optionValueRef]);//if the checkbox value IS in the array, REMOVE it

            this.emitInput(newVal);
        },
        emitInput(newVal) {
            this.$emit('input', newVal);
        },
        findCheckedOption(value) {
            //Instead of just using the value we get from the event, let's find the value in the option prop array.
            //This comes in handy, especially when dealing with Number types, as when mixing PHP and Vue Number types often get coerced into Strings one way or another.
            //example:
            //this.value = [3]; - Number type
            //e.target.value "3" - String type
            //if we search using indexOf, it will not find e.target.value in the array
            //and we do not want to use parseInt, because that will prevent us from using string values for checkboxes.
            //instead, look for the option that has been checked by looking for a direct first, and then by coercing the option value into a string and checking against that. - WE MAY NEED TO ADD FURTHER CHECKS IN THE FUTURE IN ORDER TO WORK WITH DIFFERENT TYPES
            return this.options.find(option => option[this.optionValueRef] === value || `${option[this.optionValueRef]}` === value);
        },
        selectAllGroup(groupValueArray) {
            let checkedOptionGroupValueArray = groupValueArray.map(value => this.findCheckedOption(value)[this.optionValueRef]),
                deselectAll = checkedOptionGroupValueArray.filter(value => this.value.indexOf(value) !== -1).length === groupValueArray.length,
                newVal = deselectAll
                    ? [...this.value].filter(value => !checkedOptionGroupValueArray.includes(value))
                    : [...this.value, ...checkedOptionGroupValueArray];

            this.$emit('input', newVal);
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/CheckboxComponents/GroupedCheckboxList.vue